<template>
	<div class="calculator" :class="{sideMenu}">
		<template v-if="$store.state.distance">
			<div 
				class="calculator-row" 
				v-for="row in card.type_options.rows"
				:key="row.key"
			>
				<div>
					<i :class="row.attributes.icon" v-if="row.attributes.icon"></i>
				</div>
				
				<div>
					{{ parseFormulas(row.attributes.text) }}
				</div>
			</div>
		</template>

		<div class="calculator-row" v-if=" ! $store.state.distance">
			<div>Du har inte angett någon start och slutpunkt för din resa.</div>
		</div>

		<div class="calculator-below-calc" v-html="sideMenu ? card.type_options.below_wysiwyg_side : card.type_options.below_wysiwyg"></div>

		<div class="text-right mt-3" v-if="card.type_options && card.type_options.modal_wysiwyg">
			<div class="btn calculator-open-modal" @click="openModal()" v-html="__('side_menu_how_we_calculated_btn')"></div>
		</div>

	    <v-dialog
	    	v-model="modalOpen" 
	    	width="'100%'" 
	    	max-width="900"
	    	scrollable
	    	class="dialog" 
	    	@click:outside="closeDialog()"
	    	@keydown.esc="closeDialog()"
	    	v-if="card.type_options && card.type_options.modal_wysiwyg"
	    >
	    	 
			<v-card>
				<v-card-title class="card-dialog-title">
					<div v-html="__('side_menu_how_we_calculated_title')"></div>

					<div @click="closeDialog()" class="card-dialog-close">
						<img src="@/assets/img/clear.png" width="20">
					</div>
				</v-card-title>

				<v-card-text v-html="$processText(card.type_options.modal_wysiwyg)">
					
				</v-card-text>
			</v-card>

	    </v-dialog>
	</div>
</template>

<script>
export default {
    name: 'Calculator',
    props: ['card', 'sideMenu'],

    data() {
		return {
			modalOpen: false
		}
    },

    methods: {
    	formatNum(num) {
    		return ! num ? num : num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "\u00a0")
    	},

    	openModal() {
			this.modalOpen = true
    	},

    	closeDialog() {
			this.modalOpen = false
    	},

    	parseFormulas(text) {
    		let d = this.$store.state.distance
    		let t = this.$store.state.duration

    		let formulas = text.match(/{([^}]+)}/g) || []

			formulas.forEach(formulaString => {
				let shortcode = formulaString.slice(1, -1)
				let formula = this.formulas.find(f => f.shortcode === shortcode)

				if (formula && eval(formula.formula)) {
					let value = Math.round(parseFloat(eval(formula.formula).toPrecision(2)))

					this.$store.state.parsedCalculatorShortcodes[shortcode] = this.formatNum(value).toString().replace('.', ',')

					text = text.replace(formulaString, this.formatNum(value).toString().replace('.', ','))
				}
			})

			return text
    	}
    },

    computed: {
    	formulas() {
    		return this.card.type_options.formulas2.map(f => f.attributes)
    	}
    }
}
</script>